import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UseCaseOption = ({
  useCase,
  selected,
  onToggle,
  Label,
  Icon
}) => {
  return /*#__PURE__*/_jsx(SelectableBox, {
    type: "checkbox",
    selectionMarkLocation: "top-right",
    selected: selected,
    onSelectedChange: () => onToggle(useCase),
    padding: "0",
    inlineSize: "220px",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      gap: "300",
      paddingBlock: "300",
      paddingInline: "400",
      children: [Icon, /*#__PURE__*/_jsx(Text, {
        as: "strong",
        children: Label
      })]
    })
  });
};
export default UseCaseOption;